import styled from 'styled-components';

import { MiniBadge } from '@xingternal/badge';
import { Card as CardComponent } from '@xingternal/card';
import { spaceM, spaceXS, xdlColorControlBorder } from '@xingternal/tokens';
import { Meta } from '@xingternal/typography';

import { MGapCol, SGapCol } from '../shared.styles';

export const Article = styled.article`
  height: 100%;
`;

export const Card = styled(CardComponent)`
  height: 100%;

  &:hover,
  &:focus {
    border-color: ${xdlColorControlBorder};
  }

  & > div {
    justify-content: flex-start;
    gap: ${spaceM};
    height: 100%;
  }
`;

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Date = styled(Meta)`
  display: flex;
  align-items: center;
  margin-bottom: auto;
`;

export const Notification = styled(MiniBadge)`
  margin-right: ${spaceXS};
`;

export const Details = styled(SGapCol)`
  flex: 1;
`;

export const HeaderContainer = styled(MGapCol)`
  flex: 1;
`;
